import { peso, paybackInWords } from "../../../../utils/trainingBond";
import { formatManilaDateTime } from "../../../utils/manilaTime";
import { cx } from "../../../utils/classNames";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Learning.module.css";

/**
 * The training agreement: what it costs, for how long, what leaving means, and
 * its wording. While it is still to accept, an "I have read and accept" box.
 */
const TrainingAgreement = ({ agreement, accepted, onAcceptedChange }) => {
  const isDone = !!agreement.acceptedAt;
  return (
    <div className={cx(ui.card, "p-3 mb-3")}>
      <div className={ui.fieldLabel}>Training agreement</div>
      <p className="mb-2">
        This training costs <strong>{peso(agreement.cost)}</strong>. By
        accepting, you agree to stay for{" "}
        <strong>
          {agreement.months} month{Number(agreement.months) === 1 ? "" : "s"}
        </strong>{" "}
        after it ends, if you attend.
      </p>
      <p className="mb-2">
        {paybackInWords(
          agreement.paybackRule,
          agreement.cost,
          agreement.months,
        )}
      </p>
      {agreement.terms && (
        <div className={styles.agreementTerms}>{agreement.terms}</div>
      )}
      {isDone ? (
        <p className={cx(ui.hint, "mt-2 mb-0")}>
          <i className="bi bi-check-circle text-success me-1"></i>
          You accepted on {formatManilaDateTime(agreement.acceptedAt)}.
        </p>
      ) : (
        <label className={cx(ui.checkbox, "mt-2")}>
          <input
            type="checkbox"
            checked={accepted}
            onChange={(e) => onAcceptedChange(e.target.checked)}
          />
          I have read and accept
        </label>
      )}
    </div>
  );
};

export default TrainingAgreement;
